import { cn } from "@/lib/utils";
import { ReactNode } from "react";

// 1 for each main view
// Encapsulates the main content of each page adding a max width and some padding
const Container = ({
	children,
	className,
}: {
	children?: ReactNode;
	className?: string;
}) => {
	return (
		<main
			className={cn(
				"max-w-[2000px] dark:bg-[#121212] px-2 min-h-screen lg:px-8 pt-10 pb-20 flex flex-col gap-4",
				className
			)}
		>
			{children}
		</main>
	);
};

export default Container;
